import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import i18n from "i18n";
/**
 * Information card : Title / Description / Image, click handler
 */
const InformationCard = ({
	onClick,
	selected,
	element,
	disabled = false,
	disabledErrorMessage
}) => {
	return (
		<MDBox
			m={1}
			mt={4}
			className="cardGraphChoice"
			onClick={disabled ? undefined : onClick}
			p={3}
			borderRadius="xl"
			style={{
				backgroundColor: (() => {
					if (disabled) return "#f5f5f5";
					if (selected) return "#1A73E8";
					return "";
				})(),
				border: (() => {
					if (selected) return "2px solid #1A73E8";
					return "2px solid transparent";
				})(),
				cursor: disabled ? "not-allowed" : "pointer",
				position: "relative"
			}}
			sx={{
				transition: "all 0.2s ease-in-out",
				"&:hover": {
					backgroundColor: (() => {
						if (disabled) return "#f5f5f5";
						if (selected) return "#1A73E8";
						return "#f8f9fa";
					})(),
					transform: disabled ? "none" : "translateY(-2px)",
					boxShadow: disabled ? "none" : "0 4px 20px rgba(0, 0, 0, 0.1)"
				}
			}}
		>
			<MDBox display="flex">
				<MDBox flex="1">
					<MDTypography
						variant="h3"
						color={(() => {
							if (disabled) return "text";
							if (selected) return "white";
							return "dark";
						})()}
						sx={{ opacity: disabled ? 0.7 : 1 }}
					>
						{i18n.t(element.title)}
					</MDTypography>
					<MDTypography
						variant="body2"
						color={(() => {
							if (disabled) return "text";
							if (selected) return "white";
							return "dark";
						})()}
						sx={{ opacity: disabled ? 0.7 : 1 }}
					>
						{i18n.t(element.description)}
					</MDTypography>
					{disabled && disabledErrorMessage && (
						<MDBox
							mt={2}
							p={1.5}
							borderRadius="md"
							sx={{
								backgroundColor: "rgba(244, 67, 54, 0.1)",
								border: "1px solid rgba(244, 67, 54, 0.2)"
							}}
						>
							<MDTypography variant="caption" color="error" fontWeight="medium">
								{i18n.t(disabledErrorMessage)}
							</MDTypography>
						</MDBox>
					)}
				</MDBox>
				{element.image && (
					<MDBox
						flex="3"
						position="relative"
						borderRadius="lg"
						mx={2}
						display="flex"
						justifyContent="center"
						alignItems="center"
					>
						<MDBox
							component="img"
							src={element.image}
							borderRadius="lg"
							shadow="md"
							width="auto"
							height="100%"
							position="relative"
							zIndex={1}
							maxHeight="30vh"
						/>
						<MDBox
							borderRadius="lg"
							shadow="md"
							width="100%"
							height="100%"
							position="absolute"
							left={0}
							top="3%"
							sx={{
								backgroundImage: `url(${element.image})`,
								transform: "scale(0.94)",
								filter: "blur(12px)",
								backgroundSize: "cover"
							}}
						/>
					</MDBox>
				)}
			</MDBox>
		</MDBox>
	);
};

export default InformationCard;
